/**
 * Notities (ingeklapt): de notitie op de klant en de notities uit zaken
 * (wie en wanneer). De zaaknotities laden pas als het blok open gaat,
 * want dit onderdeel staat alleen in een open uitklapblok.
 */
import { useQuery } from "@tanstack/react-query";

import { v6Api } from "../../api";
import { dagMaand, wieWoord } from "../../Rechts/opmaak";

export function Notities({ klantId, tekst }: { klantId: string; tekst: string | null }) {
  const notities = useQuery({
    queryKey: ["v6", "klant", klantId, "notities"],
    queryFn: () => v6Api.klantNotities(klantId),
  });
  // Het vrije klantveld staat al bovenaan als `tekst`; niet twee keer.
  const lijst = [...(notities.data ?? [])].filter((n) => n.sleutel !== "klantveld").sort((a, b) =>
    (a.moment ?? "") < (b.moment ?? "") ? 1 : -1,
  );
  return (
    <div className="kk-notities">
      {tekst ? <div className="kk-notitie">{tekst}</div> : null}
      {notities.isLoading ? (
        <p className="stil">Notities worden geladen.</p>
      ) : notities.isError ? (
        <p className="v6-fout" role="alert">
          De notities konden niet geladen worden.
        </p>
      ) : lijst.length === 0 && !tekst ? (
        <p className="stil">Geen notities.</p>
      ) : (
        lijst.map((n) => (
          <div className="kk-notitie" key={n.sleutel}>
            {n.tekst}{" "}
            <small>({[wieWoord(n.door_soort), dagMaand(n.moment)].filter(Boolean).join(", ")})</small>
          </div>
        ))
      )}
    </div>
  );
}
